import { $axios } from '@/utils/api'

export default function getPluginApi () {
  return {
    //* Получение элементов калькулятора по его коду
    async fetchElements (code: string) {
      if (!code) {
        return
      }

      const response = (await $axios.get(`/calculator/v1/calculators/${code}/elements`))?.data

      return response
    },

    //* Получение списка калькуляторов в зависимости от параметров
    async fetchCalculators (params: Record<string, string>) {
      const response = (await $axios.get('/calculator/v1/calculators/base-conditions', { params }))?.data

      return response
    },

    async fetchCalculatorByCode (code: string) {
      if (!code) {
        return
      }

      const response = (await $axios.get(`/calculator/v1/full/${code}`))?.data

      return response
    }
  }
}
